import { media } from "src/styles/mixins";
import styled from "styled-components";

const PageWrapper = styled.div`
  max-width: var(--page-max-width);
  padding: 0 var(--page-padding);
  margin: var(--nav-height) auto 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.up("LAPTOP")`
    min-height: calc(100vh - var(--nav-height));
    margin: 0 auto;
  `}
`;

export default PageWrapper;
